import React, { useEffect } from 'react';
import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginValidateSize from 'filepond-plugin-file-validate-size';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import PropTypes from 'prop-types';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
import { makeStyles } from '@material-ui/core/styles';
import './custom.css';
import clsx from 'clsx';

registerPlugin(FilePondPluginImagePreview);
registerPlugin(FilePondPluginFileEncode);
registerPlugin(FilePondPluginValidateSize);
registerPlugin(FilePondPluginFileValidateType);

const useStyles = makeStyles((theme) => ({
  custom: {
    fontFamily: theme.typography.fontFamily,
  },
}));

const FileUpload = ({
  name,
  onUpdate,
  files,
  className,
  labelIdle,
  labelInvalidField,
  labelFileWaitingForSize,
  labelFileSizeNotAvailable,
  labelFileLoadError,
  labelFileLoading,
  labelFileProcessing,
  labelFileProcessingComplete,
  labelFileProcessingAborted,
  labelFileProcessingError,
  labelFileRemoveError,
  labelTapToCancel,
  labelTapToRetry,
  labelTapToUndo,
  labelButtonRemoveItem,
  labelButtonAbortItemLoad,
  labelButtonRetryItemLoad,
  labelButtonAbortItemProcessing,
  labelButtonUndoItemProcessing,
  labelButtonRetryItemProcessing,
  labelButtonProcessItem,
  ...props
}) => {
  const classes = useStyles();

  useEffect(() => {
    const timeout = setTimeout(() => {
      const mylist = document.getElementsByClassName('filepond--browser');
      for (let i = 0; i < mylist.length; i++) {
        mylist[i].setAttribute('accept', '');
      }
    }, 500);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <FilePond
      allowFileEncode
      allowMultiple
      name={name}
      className={clsx(classes.custom, className)}
      labelIdle={labelIdle}
      labelInvalidField={labelInvalidField}
      labelFileWaitingForSize={labelFileWaitingForSize}
      labelFileSizeNotAvailable={labelFileSizeNotAvailable}
      labelFileLoadError={labelFileLoadError}
      labelFileLoading={labelFileLoading}
      labelFileProcessing={labelFileProcessing}
      labelFileProcessingComplete={labelFileProcessingComplete}
      labelFileProcessingAborted={labelFileProcessingAborted}
      labelFileProcessingError={labelFileProcessingError}
      labelFileRemoveError={labelFileRemoveError}
      labelTapToCancel={labelTapToCancel}
      labelTapToRetry={labelTapToRetry}
      labelTapToUndo={labelTapToUndo}
      labelButtonRemoveItem={labelButtonRemoveItem}
      labelButtonAbortItemLoad={labelButtonAbortItemLoad}
      labelButtonRetryItemLoad={labelButtonRetryItemLoad}
      labelButtonAbortItemProcessing={labelButtonAbortItemProcessing}
      labelButtonUndoItemProcessing={labelButtonUndoItemProcessing}
      labelButtonRetryItemProcessing={labelButtonRetryItemProcessing}
      labelButtonProcessItem={labelButtonProcessItem}
      files={files}
      onupdatefiles={onUpdate}
      credits={null}
      {...props}
    />
  );
};

FileUpload.propTypes = {
  name: PropTypes.string.isRequired,
  files: PropTypes.array,
  onUpdate: PropTypes.func.isRequired,
  className: PropTypes.any,
  labelIdle: PropTypes.string,
  labelInvalidField: PropTypes.string,
  labelFileWaitingForSize: PropTypes.string,
  labelFileSizeNotAvailable: PropTypes.string,
  labelFileLoadError: PropTypes.string,
  labelFileLoading: PropTypes.string,
  labelFileProcessing: PropTypes.string,
  labelFileProcessingComplete: PropTypes.string,
  labelFileProcessingAborted: PropTypes.string,
  labelFileProcessingError: PropTypes.string,
  labelFileRemoveError: PropTypes.string,
  labelTapToCancel: PropTypes.string,
  labelTapToRetry: PropTypes.string,
  labelTapToUndo: PropTypes.string,
  labelButtonRemoveItem: PropTypes.string,
  labelButtonAbortItemLoad: PropTypes.string,
  labelButtonRetryItemLoad: PropTypes.string,
  labelButtonAbortItemProcessing: PropTypes.string,
  labelButtonUndoItemProcessing: PropTypes.string,
  labelButtonRetryItemProcessing: PropTypes.string,
  labelButtonProcessItem: PropTypes.string,
};

FileUpload.defaultProps = {
  files: [],
  className: undefined,
  labelIdle:
    '<Typography variant="body2">Dra fil hit eller <span class="filepond--label-action"> Bla gjennom </span></Typography>',
  labelInvalidField: 'Feltet inneholder ugyldige filer',
  labelFileWaitingForSize: 'Venter på filstørrelse',
  labelFileSizeNotAvailable: 'Størrelse ikke tilgjengelig',
  labelFileLoadError: 'Feil under lasting',
  labelFileLoading: 'Laster',
  labelFileProcessing: 'Laster opp',
  labelFileProcessingComplete: 'Opplastning ferdig',
  labelFileProcessingAborted: 'Opplastning avbrutt',
  labelFileProcessingError: 'Feil under opplastning',
  labelFileRemoveError: 'Feil under fjerning',
  labelTapToCancel: 'Trykk for å kansellere',
  labelTapToRetry: 'Trykk for å prøve igjen',
  labelTapToUndo: 'Trykk for angre',
  labelButtonRemoveItem: 'Fjern',
  labelButtonAbortItemLoad: 'Abort',
  labelButtonRetryItemLoad: 'Prøv igjen',
  labelButtonAbortItemProcessing: 'Kanseller',
  labelButtonUndoItemProcessing: 'Angre',
  labelButtonRetryItemProcessing: 'Prøv igjen',
  labelButtonProcessItem: 'Last opp',
};

export default FileUpload;
